import { CSSObject } from '@emotion/react';

export const ButtonIncrease: CSSObject = {
  variant: 'solid',
  fontFamily: 'accent',
  fontWeight: 'normal',
  pt: '0.5',
};
